import { Navigate, useLocation, useParams } from "src/router";

/** Sends an old link to the page's own URL, keeping the rest of its path and its query, such as a comment to open. */
export const LegacyPageRedirect = ({ to }: { to: string }) => {
  const rest = useParams()["*"];
  const { search } = useLocation();
  return <Navigate to={`${to}${rest ? `/${rest}` : ""}${search}`} replace />;
};
